// core/bxdatalist.js

class BXDataList{

    
    constructor(pageSize){
        
        this.__pageSize = parseInt(pageSize); 

        this.__currentPage = 1;
        this.__startPage  =1, this.__endPage=1, this.__totalPages =1;
        this.data = [] ;
        this.__data = [] ;
        this.calcPager();

        this.__order = '';
        this.__orderBy = '';
        this.__filterPtr = function(){return true};
        this.__filterExpr = null;
    }

    get pageSize(){
        return this.__pageSize
    }
    set pageSize(value){
        this.__pageSize = parseInt(value);
        this.calcPager();
    }

    calcPager(){

        this.__startPage ;
        this.__endPage ; 
        this.__totalPages = 0;
        if(this.__data){
            this.__totalPages = Math.ceil(this.__data.length / this.__pageSize);
        }
        
        if (this.__totalPages <= 10) {
            this.__startPage = 1;
            this.__endPage = this.__totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (this.currentPage <= 6) {
                this.__startPage = 1;
                this.__endPage = 10;
            } else if (this.currentPage + 4 >= this.__totalPages) {
                this.__startPage = this.__totalPages - 9;
                this.__endPage = this.__totalPages;
            } else {
                this.__startPage = this.currentPage - 5;
                this.__endPage = this.currentPage + 4;
            }
        }

        this.__pages = [];
        
        for (let i = this.__startPage; i <=  this.__endPage; i++) {
            this.__pages .push(i);
        }
        

       
    }
    get currentPage(){
        return this.__currentPage;
    }

    set currentPage(value){
        this.__currentPage = parseInt(value);
        this.calcPager();
    }

    get startIndex(){ 
        return (this.currentPage - 1) * this.__pageSize
    }
    get endIndex(){
        return  this.startIndex + this.__pageSize
    }

    get items(){
        
        if(!this.__data ){
            return [];
        }

        return this.__data.slice(this.startIndex, this.endIndex);
    }

    set items(value){
        this.data  = value ;
        this.processData();
        this.calcPager();
        
    }

    get total(){
        return this.__totalPages;
    }

    get totalItems(){
        return this.data.length;
    }

    get pages(){

       return this.__pages ;
    }


    set order(value){
        this.__order = value
        this.processData();
    }

    get order(){
        return this.__order;
    }

    set orderBy(value){
        this.__orderBy = value
        this.processData();
    }

    get orderBy(){
        return this.__orderBy
    }

    get filterPtr(){
       return this.__filterPtr
    }

    set filterPtr(value){
        this.__filterPtr = value
        this.processData();
    }


    get filterExpr(){
        return this.__filterExpr
     }
 
    set filterExpr(value){
         this.__filterExpr = value
         this.processData();
     }
 
   


    processData(){
        
        this.__data = this.data
        
        if( !!this.__order && !!this.__orderBy){
            var property = this.__orderBy,
            sortOrder = this.__order=='ASC'?1:-1;

            this.__data = this.data.sort((a, b)=>{
                let result = (this.toIntVal(a[property]) < this.toIntVal(b[property])) ? -1 : (this.toIntVal(a[property]) > this.toIntVal(b[property])) ? 1 : 0;
                return result * sortOrder;
               
            })
        }

        if (typeof this.__filterPtr === 'function' && this.__filterExpr) {
            this.__data = this.data.filter(el=>this.__filterPtr(el, this.__filterExpr));
        }
    }
  
    toIntVal(value){
        value = parseInt(value);

        if(isNaN(value)){
            value= 0;
        }
        return value;
    }
    
}

class BXDataListAjax{

    
    constructor(pageSize){
        
        this.__pageSize = parseInt(pageSize); 

        this.__currentPage = 1;
        this.__startPage  =1, this.__endPage=1, this.__totalPages =1;
        this.totalItems = 0;
        this.calcPager();
    }

    get pageSize(){
        return this.__pageSize
    }
    set pageSize(value){
        this.__pageSize = parseInt(value);
        this.calcPager();
    }

    calcPager(){

        this.__startPage ;
        this.__endPage ; 
        this.__totalPages = 0;
   
        this.__totalPages = Math.ceil(this.totalItems / this.__pageSize);
   
        
        if (this.__totalPages <= 10) {
            this.__startPage = 1;
            this.__endPage = this.__totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (this.currentPage <= 6) {
                this.__startPage = 1;
                this.__endPage = 10;
            } else if (this.currentPage + 4 >= this.__totalPages) {
                this.__startPage = this.__totalPages - 9;
                this.__endPage = this.__totalPages;
            } else {
                this.__startPage = this.currentPage - 5;
                this.__endPage = this.currentPage + 4;
            }
        }

        this.__pages = [];
        
        for (let i = this.__startPage; i <=  this.__endPage; i++) {
            this.__pages .push(i);
        }
        

       
    }
    get currentPage(){
        return this.__currentPage;
    }

    set currentPage(value){
        this.__currentPage = parseInt(value);
        this.calcPager();
    }

    get startIndex(){ 
        return (this.currentPage - 1) * this.__pageSize
    }
    get endIndex(){
        return  this.startIndex + this.__pageSize
    }

    get total(){
        return this.__totalPages;
    }

    
    get pages(){

       return this.__pages ;
    }

   



  
    toIntVal(value){
        value = parseInt(value);

        if(isNaN(value)){
            value= 0;
        }
        return value;
    }
    
}


export {BXDataList, BXDataListAjax};


// WEBPACK FOOTER //
// ./src/core/bxdatalist.js